import type { StorePageType } from '../composables/useStore'

export default defineNuxtRouteMiddleware((to) => {
  const store = useStore()

  store.value.pageType = to.meta.pageType as StorePageType
  // reset page type id before each navigation
  store.value.pageTypeId = ''
})
